<mat-select
  [tabIndex]="tabIndex"
  [formControl]="selectCtrl"
  [compareWith]="compareWith"
  (selectionChange)="onSelectionChange()">
  <mat-option *ngFor="let item of options" [value]="item">
    {{ item.hour | number:'2.0' }}:{{ item.minute | number:'2.0' }}
  </mat-option>
</mat-select>
